import { styled } from '@mui/material';

import { Typography, Modal, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2.5),
}));

export const AppVersionModalContent = () => {
  const { t } = useI18n();

  const handleRefreshButtonClick = () => {
    window.location.reload();
  };

  return (
    <Modal data-testid="app-version-modal">
      <Modal.Header title="config:new_version_title" />
      <Modal.Content>
        <Typography variant="body1">{t('config:new_version_1')}</Typography>
        <StyledTypography variant="body1">
          {t('config:new_version_2')}
        </StyledTypography>
      </Modal.Content>
      <Modal.Controls>
        <Button variant="contained" onClick={handleRefreshButtonClick}>
          {t('config:actions.refresh')}
        </Button>
      </Modal.Controls>
    </Modal>
  );
};
